import { Boxes, Container, FileText, LayoutDashboard } from 'lucide-react';

// Segmenty adresu są po angielsku (#/dashboard, #/containers, #/stocks) —
// interfejs pozostaje po polsku, ale w URL polskie słowa wyglądają źle
// i przy znakach diakrytycznych bywają kodowane procentowo.
export const ROUTES = {
  DASHBOARD: 'dashboard',
  CONTAINERS: 'containers',
  STOCKS: 'stocks',
  REPORTS: 'reports',
};

// Pierwotna nawigacja miała dwie pozycje wyłączone na stałe ("Raporty"
// i "Ustawienia"), które nie prowadziły donikąd. "Raporty" istnieją teraz
// naprawdę i mają własny widok; atrapy w menu nadal się nie pojawiają.
export const NAV_ITEMS = [
  { id: ROUTES.DASHBOARD, label: 'Pulpit', icon: LayoutDashboard },
  { id: ROUTES.CONTAINERS, label: 'Kontenery', icon: Container },
  { id: ROUTES.STOCKS, label: 'Stocki', icon: Boxes },
  { id: ROUTES.REPORTS, label: 'Raporty', icon: FileText },
];

export const ROUTE_LABELS = {
  [ROUTES.DASHBOARD]: 'Pulpit',
  [ROUTES.CONTAINERS]: 'Zarządzanie kontenerami',
  [ROUTES.STOCKS]: 'Zarządzanie stockami',
  [ROUTES.REPORTS]: 'Raporty i rozliczenia',
};
